import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Heart } from "lucide-react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/lib/api";
import ListingCard from "@/components/ListingCard";
import { ListingCardSkeleton } from "@/components/Skeletons";

export default function Favorites() {
  const nav = useNavigate();
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({
    queryKey: ["favorites"],
    queryFn: async () => (await api.get("/favorites")).data.items,
  });

  const toggleFav = async (l) => {
    try {
      await api.post(`/favorites/${l.id}`);
      qc.setQueryData(["favorites"], (old) => old?.filter((x) => x.id !== l.id));
      toast.success("Removed from favorites");
    } catch { toast.error("Something went wrong"); }
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <div className="sticky top-0 z-30 glass flex items-center gap-3 px-4 pb-3 pt-4">
        <button onClick={() => nav(-1)} data-testid="fav-back" className="pressable glass flex h-10 w-10 items-center justify-center rounded-full">
          <ArrowLeft size={18} />
        </button>
        <h1 className="font-display text-2xl font-extrabold">Saved</h1>
      </div>

      {isLoading ? (
        <div className="grid grid-cols-2 gap-3 px-4 pt-4 md:grid-cols-3">
          {[0, 1].map((i) => <ListingCardSkeleton key={i} />)}
        </div>
      ) : (data || []).length === 0 ? (
        <div className="flex flex-col items-center px-4 py-24 text-center text-dim">
          <Heart size={48} className="mb-4 opacity-40" />
          <p className="font-display text-lg font-bold" style={{ color: "var(--text)" }}>No saved listings yet</p>
          <p className="mt-1 text-sm">Tap the heart on any listing to save it here</p>
          <button onClick={() => nav("/browse")} className="btn-accent mt-5 px-6 py-2.5 font-bold">Browse market</button>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-3 px-4 pt-4 md:grid-cols-3">
          {data.map((l, i) => (
            <ListingCard key={l.id} listing={l} index={i} onOpen={() => nav(`/listing/${l.id}`)} onToggleFav={toggleFav} />
          ))}
        </div>
      )}
    </motion.div>
  );
}
